"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEntityProperties = void 0;
function getEntityProperties(propertyNames = [], schema, schemas) {
    var _a, _b;
    const [propertyName, ...relations] = propertyNames;
    const currRelation = (_a = schema === null || schema === void 0 ? void 0 : schema.relations) === null || _a === void 0 ? void 0 : _a.find(relation => relation.propertyName === propertyName);
    const properties = [
        {
            schema,
            propertyName,
            relation: currRelation,
            relationSchema: schemas.find(schema => schema.name === (currRelation === null || currRelation === void 0 ? void 0 : currRelation.target))
        }
    ];
    for (const propertyName of relations) {
        // get entitySchema and relation based on previous property
        const previous = properties[properties.length - 1];
        const schema = schemas.find(schema => { var _a; return schema.name === ((_a = previous.relation) === null || _a === void 0 ? void 0 : _a.target); });
        const relation = (_b = schema === null || schema === void 0 ? void 0 : schema.relations) === null || _b === void 0 ? void 0 : _b.find(relation => relation.propertyName === propertyName);
        properties.push({
            schema,
            propertyName,
            relation,
            relationSchema: schemas.find(schema => schema.name === (relation === null || relation === void 0 ? void 0 : relation.target))
        });
    }
    return properties;
}
exports.getEntityProperties = getEntityProperties;
//# sourceMappingURL=entity-property.js.map